export default __webpack_public_path__ + "navigation-overview-quickstart-result-960-4e7cb0d01ca474be119a283f40950a29.webp";